import { getProperty } from '@/common/oldMobile';
import { makeBotDefence } from '@/botdefence/botDefenceInstance';

const snapshotBotDefence = makeBotDefence(getProperty('__b_d_P_E'));

export default snapshotBotDefence;
